import {
  PaidFlowTypesEnum,
  PaymentMethodTypesEnum,
} from "@propertelligent/client-api";
import type { TransactionRow } from "./transactionTypes";

export const canDeleteTransaction = (
  transaction?: Pick<TransactionRow, "paymentMethodTypeId"> | null,
) => transaction?.paymentMethodTypeId !== PaymentMethodTypesEnum.Plaid;

export const canRefundTransaction = (
  transaction?: Pick<
    TransactionRow,
    "paymentMethodTypeId" | "paymentDueAccountPaidFlowTypeId"
  > | null,
) =>
  transaction?.paymentMethodTypeId === PaymentMethodTypesEnum.Plaid &&
  transaction?.paymentDueAccountPaidFlowTypeId ===
    PaidFlowTypesEnum.Receiveable;
